<template>
  <div id="app" :class="[navIsOpen]">
    <splash v-if="!noSplash" />
    <template v-if="onlyView">
      <router-view></router-view>
    </template>
    <template v-else>
      <MainPageWrapper
        :logo="{ url: '/img/logos/dayz-logo.svg', alt: 'Dayz logo' }"
        :activeRoute="activeRoute"
        :nav-links="navLinks"
        :social-links="socialLinks"
      >
        <PageLoader v-show="loading" />

        <div v-show="!loading">
          <main class="main-wrapper" :class="[wrapperClass]">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </main>

          <MainFooter
            class="js-main-footer"
            :social-links="socialLinks"
            :copyrightLinks="copyrightLinks"
          />
        </div>
      </MainPageWrapper>
    </template>

    <Notifications />
  </div>
</template>

<script>
import { mapActions } from "vuex";

import Splash from "./components/Landing";

import Notifications from "./components/Notifications.vue";
import MainFooter from "@/components/MainFooter";
import MainPageWrapper from "@/components/MainPageWrapper";
import PageLoader from "./components/common/PageLoader";
import {
  HOME_PAGE_NAME,
  DEVHUB_PAGE_NAME,
  FAQ_PAGE_NAME,
  BUY_PAGE_NAME,
} from "./router/pageNameConstants";

export default {
  name: "app",
  components: {
    Splash,
    MainFooter,
    Notifications,
    MainPageWrapper,
    PageLoader,
  },
  data() {
    return {
      navLinks: [
        { url: { name: HOME_PAGE_NAME }, name: "home", exact: true },
        { url: { name: DEVHUB_PAGE_NAME }, name: "Dev hub" },
        { url: "https://forums.dayz.com/", name: "forums", external: true },
        { url: { name: FAQ_PAGE_NAME }, name: "Faq" },
        {
          url: "https://data.bistudio.com/press/dayz/DayZ_Press_Kit.zip",
          name: "Press kit",
          external: true,
        },
        { url: "https://minidayz.com/", name: "Mini DayZ", external: true },
        {
          url: "https://store.bistudio.com/collections/dayz",
          name: "MERCH",
          external: true,
        },
        { url: { name: BUY_PAGE_NAME }, name: "Buy DayZ now", button: true },
      ],
      socialLinks: [
        {
          url: "//www.facebook.com/DayZ",
          label: "follow dayz on facebook",
          type: "facebook",
        },
        {
          url: "//twitter.com/dayz",
          label: "follow dayz on twitter",
          type: "twitter",
        },
        {
          url: "//www.youtube.com/user/DayZDevTeam",
          label: "follow dayz on youtube",
          type: "youtube",
        },
        {
          url: "//www.twitch.tv/dayz",
          label: "follow dayz on twitch",
          type: "twitch",
        },
      ],
      copyrightLinks: [
        { url: "//www.bistudio.com/cookie-policy", name: "Cookies" },
        { url: "//www.bistudio.com/privacy-policy", name: "Privacy Policy" },
        {
          url:
            "https://www.bohemia.net/community/licenses/dayz-end-user-license",
          name: "Dayz Eula",
        },
        {
          url: "https://store.steampowered.com/eula/223350_eula_0",
          name: "Server Eula",
        },
      ],
      description:
        "DayZ is a gritty, authentic, open-world survival horror hybrid-MMO game, players follow a single goal: Survive by any mean necessary.",
    };
  },
  metaInfo() {
    return {
      titleTemplate(titleChunk) {
        // If undefined or blank then we don't need the hyphen

        return titleChunk && titleChunk !== "Home"
          ? `${titleChunk} | DayZ | Official website`
          : "DayZ | Official website";
      },
      meta: [
        // TODO: test it in facebook and twitter debugger
        { vmid: "description", name: "description", content: this.description },
        {
          vmid: "og:description",
          property: "og:description",
          content: this.description,
        },
        { property: "og:url", content: this.url }, // TODO: must be dynamic
        { vmid: "og:type", property: "og:type", content: "website" }, // TODO: change to article in articles page
        {
          vmid: "og:image",
          property: "og:image",
          content: "/img/dayz_thumb.jpg",
        },
        { property: "og:title", conent: "" }, // TODO: add dynamic title
      ],
    };
  },
  computed: {
    navIsOpen() {
      return this.$store.state.settings.navIsOpen;
    },
    activeRoute() {
      return this.$route.name;
    },
    wrapperClass() {
      return this.$route.meta.class || "";
    },
    onlyView() {
      return this.$route.meta.onlyView;
    },
    noSplash() {
      return this.$route.meta.noSplash;
    },
    loading() {
      return this.$store.state.settings.loading;
    },
    url() {
      return location.href;
    },
    subHeader() {
      return this.$route.meta.subHeader;
    },
  },
  methods: {
    ...mapActions("user", ["loadUser"]),
    ...mapActions("settings", ["getSettings"]),
  },
  async created() {
    await this.loadUser();
    await this.getSettings();
    // set current base url for proper og tags
    this.$store.commit("settings/setOrigin", window.location.origin);
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.main-wrapper {
  // min-height: 80vh;
  min-height: 60vh;
}

#app {
  /*overflow: hidden;*/
}
</style>
